import { ReactNode } from 'react';

import AuthFooter from 'components/AuthFooter';

import alIndiaLogo from 'media/alIndiaLogo.png';

const CHANGELOG_URL = 'https://www.angellistindia.com/post/changelog';

export default function AuthSplitLayout({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-5xl overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm lg:flex">
        <a
          href={CHANGELOG_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:flex lg:w-1/2 relative flex-col justify-center overflow-hidden bg-[linear-gradient(160deg,#fff7ed_0%,#fef1e8_45%,#eef2ff_100%)] px-14 py-12 transition-opacity hover:opacity-95"
        >
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-10 -top-8 h-32 w-32 rounded-full bg-orange-300/50"
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute bottom-12 right-5 h-16 w-16 rounded-full bg-indigo-300/40"
          />

          <p className="relative text-xs font-semibold uppercase tracking-widest text-indigo-600">
            WHAT'S NEW ON ANGELLIST INDIA
          </p>

          <h3 className="relative mt-3 leading-tight">
            <span className="block font-serif text-4xl italic text-gray-800">Investing,</span>
            <span className="block text-4xl font-extrabold text-gray-900">Reimagined.</span>
          </h3>

          <p className="relative mt-3 max-w-[36ch] text-sm leading-relaxed text-gray-600">
            We ship new features every month. Check out the Changelog to see what&apos;s new.
          </p>

          <div
            aria-hidden="true"
            className="relative mt-8 w-full -rotate-3 rounded-xl bg-gray-100 p-3 shadow-2xl"
          >
            <div className="mb-3 flex gap-1.5">
              <span className="h-2.5 w-2.5 rounded-full bg-red-400" />
              <span className="h-2.5 w-2.5 rounded-full bg-yellow-400" />
              <span className="h-2.5 w-2.5 rounded-full bg-green-400" />
            </div>
            <div className="flex gap-2 rounded-lg bg-white p-3">
              <div className="w-6 rounded-md bg-indigo-100" />
              <div className="flex-1">
                <div className="mb-2 flex h-14 items-end gap-1">
                  <div className="flex-1 rounded-sm bg-indigo-400" style={{ height: '40%' }} />
                  <div className="flex-1 rounded-sm bg-indigo-400" style={{ height: '65%' }} />
                  <div className="flex-1 rounded-sm bg-indigo-400" style={{ height: '50%' }} />
                  <div className="flex-1 rounded-sm bg-orange-300" style={{ height: '85%' }} />
                  <div className="flex-1 rounded-sm bg-indigo-400" style={{ height: '70%' }} />
                  <div className="flex-1 rounded-sm bg-indigo-400" style={{ height: '95%' }} />
                </div>
                <div className="flex gap-1.5">
                  <div className="h-4 flex-1 rounded bg-indigo-50" />
                  <div className="h-4 flex-1 rounded bg-indigo-50" />
                  <div className="h-4 flex-1 rounded bg-indigo-50" />
                </div>
              </div>
            </div>
          </div>

          <span className="relative mt-8 inline-flex w-fit items-center rounded-full bg-gray-900 px-4 py-2 text-sm font-semibold text-white">
            View full Changelog
            <span aria-hidden="true" className="ml-1">
              &rarr;
            </span>
          </span>
        </a>

        <div className="flex flex-1 flex-col justify-center px-4 py-10 sm:px-10 lg:px-12">
          <div className="mx-auto w-full max-w-sm">
            <img className="mx-auto h-10 w-auto" src={alIndiaLogo} alt="AngelList India" />
            <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-600">
              {title}
            </h2>
          </div>

          <div className="mt-8 mx-auto w-full max-w-sm">{children}</div>

          <AuthFooter styles="mt-8" />
        </div>
      </div>
    </div>
  );
}
